import { type CbhIconProps } from "@clipboard-health/ui-components";

import { type Consequence } from "./ConsequencePill";

export function getIcon(consequence: Consequence): CbhIconProps["type"] {
  if (consequence === "Instant restriction") {
    return "triangle-exclamation";
  }

  if (consequence === "On Restriction" || consequence === 0) {
    return "minus";
  }

  if (consequence === "Restriction" || consequence < 0) {
    return "arrow-down";
  }

  return "arrow-up";
}
